import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AktiveFilterService } from '../../../services/filter/aktive-filter.service';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';

@Component({
  selector: 'now-wbsuche-lib-mobile-show-filter-button',
  templateUrl: 'mobile-show-filter-button.component.html',
  imports: [NgClass, AsyncPipe]
})
export class MobileShowFilterButtonComponent {
  private readonly screenSizeService = inject(ScreenSizeService);
  aktiveFilterService = inject(AktiveFilterService);

  @Input() public showFacettenFilterbuttonMobil!: boolean | null;

  isTabletOrBigger$ = this.screenSizeService.rangeFrom$(ViewMode.DESKTOP);
  isSmartPhone = toSignal(this.screenSizeService.rangeTo$(ViewMode.PHONE));
}
